import React from 'react'
import GenericModal from '../../../components/modal/GenericModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const LineamientosPrestamo = ({ showModal }) => {
    return (
        <GenericModal titulo="Lineamientos de Préstamos y Adelantos" showModal={showModal} width='950px'>
            <div className="modal-body">
                
                <div className="mb-3 text-right">
                    <a href="https://drive.google.com/file/d/1yRPgDqPZ52C2C53EGFqb0gw3ULqQtpyH/view?usp=drive_link"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn generic-button-buscador">
                        <FontAwesomeIcon icon="file-pdf" className="mr-1" />
                        Mira aquí la política
                    </a>
                </div>
                

                <div className="mb-3">
                    <h6 className="modal-label font-weight-bold">Condiciones</h6>
                    <ul className="ficha-declaracion-jurada-message pl-4">
                        <li>Solo se otorgará un préstamo en el año (una vez solicitada el préstamo ya no podrás acceder a un adelanto de gratificación regular o de sueldo).</li>
                        <li>Si el colaborador mantiene un adelanto de gratificación pendiente de pago, no se habilitará la opción para solicitar un préstamo, adelanto de sueldo o adelanto de gratificación regular.</li>
                        <li>Una vez cancelado en su totalidad el préstamo o adelanto de gratificación regular o de sueldo, podrá habilitarse la opción de adelanto de gratificación sin restricciones.</li>
                        
                    </ul>
                </div>

                

                <hr />

                <div className="mb-3">
                    <h6 className="modal-label font-weight-bold">Consideraciones generales</h6>
                    <ul className="ficha-declaracion-jurada-message pl-4">
                        <li>El monto solicitado no generará intereses, salvo que equivalga a un monto superior a 1 UIT, en dichos casos se aplicarán los intereses correspondientes.</li>
                        <li>Si el colaborador cesa de Colegios Peruanos S.A. antes de cancelar un préstamo y/o un adelanto de gratificación regular o de sueldo, el saldo pendiente podrá ser descontado de su liquidación de beneficios laborales.</li>
                        <li>Todas las solicitudes de préstamo, adelanto de sueldo y/o gratificación estarán sujetas a evaluación de sustentos, remuneraciones y nivel de endeudamiento del colaborador para su aprobación. Excepción el adelanto de gratificaciones sin restricciones (esta está disponible según el punto 07 de la política).</li>
                        <li>Los beneficios de préstamo, adelanto de sueldo o adelanto de gratificación regular podrán solicitarse una sola vez por año, pudiendo acceder únicamente a uno de ellos.</li>                       
                        <li>Adicionalmente, el colaborador podrá acceder al beneficio de adelanto de gratificación sin restricciones, siempre que no mantenga vigente ni pendiente de pago ningún préstamo, adelanto de gratificación regular o adelanto de sueldo.</li>
                    </ul>
                </div>

                <hr />

                <div className="mb-3">
                    <h6 className="modal-label font-weight-bold">Sobre los motivos</h6>
                    <ol className="ficha-declaracion-jurada-message pl-4">
                        <li>Salud de familiares directos (hijos/as, conyugue, conviviente, padres, hermanos) Sepelio de un familiar directo.</li>
                        <li>Gastos escolares (útiles escolares y matrícula IS), no aplica para pagar pensión escolar y/o pensión universitaria.</li>
                        <li>Gastos de trámites de titulación del colaborador de Colegios Peruanos S.A.</li>
                        <li>Cursos o diplomados que estén acorde con el crecimiento profesional del colaborador/a en Colegios Peruanos S.A.</li>
                    </ol>
                </div>

                <hr />

                <div className="mb-3">
                    <h6 className="modal-label font-weight-bold">Requisito de antigüedad</h6>
                    {/* <ul className="ficha-declaracion-jurada-message pl-4">
                        <li>Toda la información proporcionada debe ser verídica y respaldada con documentación</li>
                        <li>Las solicitudes observadas deberán ser corregidas por el colaborador</li>
                        <li>Los montos aprobados no pueden exceder el límite establecido salvo excepciones</li>
                        <li>El plazo de aprobación es de <strong>3 a 5 días hábiles</strong> desde la fecha de solicitud</li>
                    </ul> */}

                    {/* TODO: aqui colocar una tabla de dos columnas: "Tipo de Solicitud" y "Antigüedad Requerida", y colocar los requisitos de antiguedad para cada tipo de solicitud
                    Registros: */}
                    <table className="table table-bordered mt-2">
                        <thead>
                            <tr>
                                <th>Tipo de Solicitud</th>
                                <th>Antigüedad Requerida</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Préstamo</td>
                                <td>6 meses</td>
                            </tr>
                            <tr>
                                <td>Adelanto de sueldo</td>
                                <td>3 meses</td>
                            </tr>
                            <tr>
                                <td>Adelanto de gratificación regular</td>
                                <td>6 meses</td>
                            </tr>
                            <tr>
                                <td>Adelanto de gratificación sin restricción</td>
                                <td>6 meses</td>
                            </tr>
                        </tbody>
                    </table>

                </div>

                <hr />

                <div className="mb-3">
                    <h6 className="modal-label font-weight-bold">Campañas para solicitudes de adelanto de gratifiación sin restricción</h6>
                    <table className="table table-bordered mt-2">
                        <thead>
                            <tr>
                                <th>Campaña</th>
                                <th>Vigencia</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Mayo</td>
                                <td>Desde el 01 al 15 de abril</td>
                            </tr>
                            <tr>
                                <td>Setiembre</td>
                                <td>Desde el 01 al 15 de agosto</td>
                            </tr>
                            <tr>
                                <td>Noviembre</td>
                                <td>Desde el 01 al 15 de octubre</td>
                            </tr>                            
                        </tbody>
                    </table>
                </div>

                <hr />

                <div className="mb-3">
                    <h6 className="modal-label font-weight-bold">Períodos válidos para solicitudes de adelanto de gratifiación regular</h6>
                    <table className="table table-bordered mt-2">
                        <thead>
                            <tr>
                                <th>Gratificación</th>
                                <th>Período</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Julio</td>
                                <td>Desde el 01 de febrero al 03 de julio</td>
                            </tr>
                            <tr>
                                <td>Diciembre</td>
                                <td>Desde el 01 de agosto al 04 de diciembre</td>
                            </tr>   
                        </tbody>
                    </table>
                </div>



            </div>

            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-primary generic-button-ficha mr-2"
                    onClick={showModal}
                >
                    Cerrar
                </button>
            </div>
        </GenericModal>
    );
};

export default LineamientosPrestamo;
